var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCheckCircled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2308",
    "data-name": "Group 2308",
    transform: "translate(-227.5 -582.262)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2333",
    "data-name": "Rectangle 2333",
    width: 32,
    height: 32,
    rx: 16,
    transform: "translate(227.5 582.262)",
    fill: "#fffefa",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2194",
    "data-name": "Group 2194",
    transform: "translate(-87.7 -2133.738)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Subtraction_24",
    "data-name": "Subtraction 24",
    transform: "translate(321 2722)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2,0A10,10,0,1,1,.2,10,10,10,0,0,1,10.2,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 10.20022296905518 2.000429153442383 C 5.788923263549805 2.000429153442383 2.200063705444336 5.589019775390625 2.200063705444336 10 C 2.200063705444336 14.41098022460938 5.788923263549805 17.99956893920898 10.20022296905518 17.99956893920898 C 14.61152267456055 17.99956893920898 18.20038223266602 14.41098022460938 18.20038223266602 10 C 18.20038223266602 5.589019775390625 14.61152267456055 2.000429153442383 10.20022296905518 2.000429153442383 M 10.20022296905518 0.0004291534423828125 C 15.72315311431885 0.0004291534423828125 20.20038223266602 4.477390289306641 20.20038223266602 10 C 20.20038223266602 15.52260971069336 15.72315311431885 19.99957084655762 10.20022296905518 19.99957084655762 C 4.67728328704834 19.99957084655762 0.2000637054443359 15.52260971069336 0.2000637054443359 10 C 0.2000637054443359 4.477390289306641 4.67728328704834 0.0004291534423828125 10.20022296905518 0.0004291534423828125 Z",
    stroke: "none",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2316",
    "data-name": "Path 2316",
    d: "M-3.947.287,2.273,0V3.476",
    transform: "translate(244.278 598.847) rotate(135)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckCircled);
export default __webpack_public_path__ + "static/media/icon-check-circled.1e49994c.svg";
export { ForwardRef as ReactComponent };